import {  batchUpdateStrategyObject, getResumeCondition} from '@/api/ad'
import ToolTipBox from "@/views/modules/ad/strategy/time-adjust/modal/tool-tip-box/tool-tip-box";
//分时策略判断是否需要执行还原(只针对修改分时策略状态)
export async function  getResumeConditionInfo(objectPid, row, callback ) {
    let params = [{
        operatingType: 1,// 操作类型（0:修改模板，1：修改策略）
        objectPid: objectPid,
        status: 1,
      }]
      try {
        var data = [];
        data = await getResumeCondition(params)
        var resume = false
        if (data.length > 0) {
            let info = data[0];
            resume = info.resumeDTO.resume ? info.resumeDTO.resume : false
        } 
        let useParams = [{
            marketId: row.marketId,
            objectPid: objectPid,
            objectStatus: 2,//(0：开启，1：关闭，2：归档)
            resume: resume,
        }];
        batchUpdateStrategyObject(useParams).then(res => {
            if (res.code === 0) {
                callback('success');
            }else {
                callback('error');
            }
        }).catch(error => {
            callback('error');
        })
      } catch (error) {
        callback('error')
      } 
}

export const deleteStrategy = (_this, row) => {
    const modal = _this.$gjCreate('gj-info-modal', {
        props: {
            title: '移除确认',
            content: `确定要移除分时策略吗？请谨慎操作！`
        },
        on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
                queryFront();
            }
        }
    });

    async function updateData(resume, resumeTaskId) {
        const res = await batchUpdateStrategyObject([{
            marketId: row.marketId,
            objectPid: row.objectId,
            objectStatus: 2,
            resume,
            resumeTaskId,
        }]);
        res.code === 0 ? _this.$message.success(res.msg) : _this.$message.error(res.msg);
        modal && modal.$gjDestroy();
        _this.$gjResetPage();
    }

    const queryFront = async () => {
        const frontData = await getResumeCondition([{ objectPid: row.objectId, operatingType: 1, status: 2 }]);
        // 判断检测到有需要还原的数据
        if (frontData && frontData.length) {
            const modal2 = _this.$gjCreate(ToolTipBox, {
                props: {
                    msg: "分时调价策略正在生效中，请确认是否需要将预算和竞价恢复到基础预算和竞价",
                    data: frontData,
                },
                on: {
                    update: (resume, resumeTaskId) => {
                        if (resume !== -1) {
                            // resume为true表示需要还原
                            resume ? updateData(resume, resumeTaskId) : updateData();
                        } else {
                            // 等于 -1 表示取消
                            modal2.$gjDestroy();
                            modal && modal.$gjDestroy();
                        }
                    },
                },
            });
        } else {
            updateData();
        }
    }
}